import { PitchShiftWindow } from "@/types/defs/audioQuality/pitchShiftWindow";

// Calculates the allowed pitch shift window for a given user sample and artist range. min (max shift down) = artist_low  − sample_low max (max shift up)   = artist_high − sample_high
export const calculatePitchShiftWindow = (
  user: { low: number; high: number },
  artist: { low: number; high: number }
): PitchShiftWindow => ({
  min: artist.low - user.low,
  max: artist.high - user.high,
});
